export default __webpack_public_path__ + "static/media/value-supportive.1817fbba.svg";